import { useMemo } from 'react';
import * as S from '../components/Tooltip/Tooltip.styled';
import { chartColors } from '../consts';
import { formatValue } from '../utils/formatValue';
import { getMinValue } from '../utils/getMinValue';
export const useChartOptions = ({ data, isLoading, showAxes = true, tooltipFormatter, yAxisFormatter, xAxisFormatter, animation = true, appearance = 'light', }) => {
    const colors = useMemo(() => {
        return chartColors[appearance].general;
    }, [appearance]);
    const xAxisLabels = useMemo(() => data[0]?.data.map((p) => p.label) ?? [], [data]);
    const baseOptions = useMemo(() => ({
        showSpinner: isLoading,
        animation,
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'transparent',
            borderWidth: 0,
            extraCssText: 'box-shadow:none;padding:0',
            formatter: (tooltipParams) => {
                const paramsArray = Array.isArray(tooltipParams) ? tooltipParams : [tooltipParams];
                const axisValue = paramsArray[0]?.axisValue;
                const label = formatValue(typeof axisValue === 'number' ? String(axisValue) : (axisValue ?? ''), tooltipFormatter?.xAxisFormatter, xAxisFormatter);
                const tooltipSeries = paramsArray
                    .map((serieTooltipParams) => {
                    const value = formatValue(serieTooltipParams.value, tooltipFormatter?.yAxisFormatter, yAxisFormatter);
                    return `
              <div style="${S.TooltipItemContainerStyles}">
                <div style="${S.TooltipItemPointStyles}; background: ${serieTooltipParams.color}; display: ${paramsArray.length > 1 ? 'block' : 'none'}"></div>
                <div style="${S.TooltipItemContentStyles}">
                  <div style="${S.TooltipItemLabelStyles}">${label}</div>
                  <div style="${S.TooltipItemValueStyles}">${value}</div>
                </div>
              </div>`;
                })
                    .join('');
                return `
            <div style="${S.TooltipStyles}">
              ${tooltipSeries}
            </div>
          `;
            },
        },
        grid: {
            top: 10,
            bottom: 0,
            left: 0,
            right: 0,
            containLabel: false,
        },
        xAxis: {
            type: 'category',
            data: xAxisLabels,
            show: showAxes,
            axisLine: { lineStyle: { color: colors.axisLine } },
            axisLabel: {
                show: showAxes,
                formatter: (value) => formatValue(value, xAxisFormatter),
                color: colors.axisLabel,
                fontSize: 12,
                interval: 'auto',
                rotate: 0,
                hideOverlap: true,
                width: 60,
                overflow: 'break',
            },
        },
        yAxis: {
            type: 'value',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            show: showAxes,
            axisLine: { show: false },
            splitLine: { show: showAxes, lineStyle: { color: colors.splitLine } },
            min: (extent) => extent.min === extent.max ? undefined : getMinValue(data),
            max: (extent) => extent.min === extent.max ? extent.max + 100 : undefined,
            axisLabel: {
                show: showAxes,
                formatter: (value) => formatValue(value, yAxisFormatter),
                color: colors.axisLabel,
                fontSize: 12,
                margin: 16,
            },
        },
    }), [
        isLoading,
        animation,
        showAxes,
        xAxisLabels,
        xAxisFormatter,
        yAxisFormatter,
        colors,
        data,
        tooltipFormatter?.xAxisFormatter,
        tooltipFormatter?.yAxisFormatter,
    ]);
    return {
        baseOptions,
        colors,
        xAxisLabels,
    };
};
